import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";

var _Grid$Row;

import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from "../../Typography/Text";
import Heading from "../../Typography/Heading";
import Button from "../../Controls/Button";
import Container from "../../Common/Container";
import PromoHeading from "../../Typography/PromoHeading";
import Grid from "../Grid";
import styles from './PageErrorLayout.scss';

var PageErrorLayout = function PageErrorLayout(_ref) {
  var description = _ref.description,
      buttonText = _ref.buttonText,
      onClick = _ref.onClick,
      errorCode = _ref.errorCode;

  var _useTranslation = useTranslation(['dsPageError']),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement("div", {
    className: styles.pageError
  }, /*#__PURE__*/React.createElement(Grid.Container, null, /*#__PURE__*/React.createElement(Container, {
    paddingBottom: 10
  }, _Grid$Row || (_Grid$Row = /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Item, {
    xl: 5,
    lg: 5,
    sm: 4,
    xs: 4
  }, /*#__PURE__*/React.createElement(Container, {
    marginTop: 10,
    marginTopSm: 3,
    marginTopXs: 3
  }, /*#__PURE__*/React.createElement(PromoHeading, {
    level: 1
  }, "Ooops!"))))), /*#__PURE__*/React.createElement("div", {
    className: styles.image
  }, "\xA0"), /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Item, {
    xl: 4,
    lg: 4,
    sm: 4,
    xs: 4
  }, /*#__PURE__*/React.createElement(Container, {
    marginTop: 4,
    marginTopSm: 3,
    marginTopXs: 3
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 2
  }, description)), /*#__PURE__*/React.createElement(Container, {
    marginTop: 1
  }, /*#__PURE__*/React.createElement(Container, {
    paddingRight: 5
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    color: "label"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "label"
  }, t('CODE_LABEL')))), /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    size: "small"
  }, errorCode)), /*#__PURE__*/React.createElement(Button, {
    onClick: onClick,
    className: styles.button,
    styleType: "primary"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    color: "text-inverted"
  }, buttonText)))))));
};

export default PageErrorLayout;